var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.footer},[_c('div',{class:_vm.$style.footerInner},[_c('a',{class:_vm.$style.logo,attrs:{"href":"#","rel":"noopener noreferrer"}},[_vm._v(" ONYX Risk Mgr "),_c('span')]),_c('br'),_c('p',{staticClass:"mb-0"},[_vm._v(" ©2020 BitJar Labs ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }